;(function (angular, _) {
  'use strict'

  class SelectReferersController {
    constructor (
      // Angular
      // Libs
      // Managers
      // Services
      ReferersService
      // Const
      // Resolved
    ) {
      this.referersService = ReferersService
    }

    get referers () {
      return this.ngModel.$viewValue
    }

    set referers (value) {
      this.ngModel.$setViewValue(value)
    }

    selectReferers () {
      return this.referersService.promptSelection(this.referers)
        .then((referers) => {
          this.referers = referers
        })
    }
  }

  SelectReferersController.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    'ReferersService'
    // Const
    // Resolved
  ]
  angular.module('kilo.common.components')
    .component('selectReferers', {
      require: {
        ngModel: 'ngModel'
      },
      bindings: {
        disabled: '<'
      },
      controller: SelectReferersController,
      templateUrl: '/app/common/components/select-referers/select-referers.template.html'
    })
})(window.angular, window._)
